import { z } from 'zod';

export const passwordRecoveryInputSchema = z
  .object({ email: z.string().trim().toLowerCase().email().max(254) })
  .strict();

export interface PasswordRecoveryReceipt {
  status: 'received';
}
